import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { UsersHttpClient } from '@omnea-app/users/usersHttpClient'

interface GetOutOfOfficeDelegatesProps {
  delegatorId: string
}

export const outOfOfficeDelegatesQueryKey = (delegatorId: string) => ['GetDelegatesForOutOfOfficeDelegation', delegatorId]

export const useGetOutOfOfficeDelegates = ({ delegatorId }: GetOutOfOfficeDelegatesProps) => {
  const enabled = !!delegatorId
  const { getToken } = useAuthenticatedUser()
  return useQuery({
    queryKey: outOfOfficeDelegatesQueryKey(delegatorId),
    queryFn: async () => {
      const token = await getToken()
      const apiClient = new UsersHttpClient({ omneaJwt: token })
      const { data } = await apiClient.GET('/out-of-office/{delegatorId}', {
        params: { path: { delegatorId } },
      })
      return data
    },
    enabled,
  })
}
